import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(VSelect, {
        attrs: { items: _vm.auditTables },
        model: {
          value: _vm.selectedTable,
          callback: function ($$v) {
            _vm.selectedTable = $$v
          },
          expression: "selectedTable",
        },
      }),
      _vm.selectedTable
        ? _c(VBtn, { on: { click: _vm.inspectTable } }, [
            _vm._v("Inspect Table"),
          ])
        : _vm._e(),
      _c(
        "pre",
        {
          staticStyle: { "white-space": "pre-wrap" },
          attrs: { id: "console" },
        },
        [_vm._v(_vm._s(_vm.tableStatus || "No Status"))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }